
/*工具函数*/
export const getDataType = value => {
  //返回数据类型 [] => array , 0 => number,  "a" => string, {} => object 等;
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase()
};



export const getUrlParams = (url, key) => {
  let search = url && url.split("?")[1];
  var theRequest = {};
  let query = search && search.split("&");
  for (let i = 0; i < query.length; i++) {
    theRequest[query[i].split("=")[0]] = decodeURI(query[i].split("=")[1]);
  }
  return key ? theRequest[key] : theRequest;
};

export const getIsWxClient = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};